import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Image} from 'semantic-ui-react';

export const UserProfileImage = ({src, alt}: {src?: string; alt?: string}) => {
  if (src == null) {
    return <Icon name="users-team" />;
  }

  return (
    <Image
      src={src}
      onError={(img: any) => (img.target.style.visibility = 'hidden')}
      avatar
      alt={alt}
      style={{
        filter: 'none', // important to prevent scary images in dark mode
        width: '24px',
        height: '24px',
        objectFit: 'contain',
        margin: 0,
        flexShrink: 0,
      }}
    />
  );
};
